import { openModal } from "../PopUp.tsx";
import { useContext } from "react";
import { PageSizeContext } from "../../../context/context.page";
import { useItemCount } from "../../item/core/ItemQueryCount";
import { useSearchParamsHandler } from "../../../hooks/useSearchParamsHandler.ts";

const PageButton = () => {
  const itemCount = useItemCount();
  const { pageSize } = useContext(PageSizeContext);
  const { get, set } = useSearchParamsHandler("page");
  const pages = Math.floor((itemCount - 1) / pageSize);

  const currentPage = isNaN(Number(get()[0])) ? 0 : Number(get()[0]);

  const selectPage = (from: number, offset: number) => {
    if (from > pages) {
      set(String(pages));
    } else if (from < 0) {
      set(String(0));
    } else {
      set(String(from + offset));
    }
    scrollTo({ top: 0 });
  };
  return (
    <div className="join">
      <button
        className={`join-item btn ${currentPage < 1 && "btn-disabled"}`}
        onClick={() => selectPage(currentPage, -1)}
      >
        «
      </button>
      <button className="join-item btn" onClick={() => openModal("pages")}>
        Seite {currentPage + 1}
      </button>
      <button
        className={`join-item btn ${currentPage >= pages && "btn-disabled"}`}
        onClick={() => selectPage(currentPage, 1)}
      >
        »
      </button>
    </div>
  );
};
export default PageButton;
